import { FC } from 'react';
import { Divider, Modal } from 'shared';

interface IProps {
  open: boolean;
  onClose: () => void | Promise<void>;
}

export const NotEnoughCreditsModal: FC<IProps> = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      noPadding
      widthClasses="yep_ex-w-[18rem] sm:yep_ex-w-96"
    >
      <div className="yep_ex-text-center">
        <h3 className="yep_ex-text-lg yep_ex-font-semibold yep_ex-py-5">
          Not Enough Credits
        </h3>
        <Divider />
        <div className="yep_ex-p-4">
          <p className="yep_ex-text-sm yep_ex-text-gray-700">
            You do not have enough credits.
            <br />
            Your plan does not support automatic credit top-up.
          </p>
        </div>
      </div>
    </Modal>
  );
};
